import PaginatedListSerializer from 'lumen/serializers/paginated-list';

export default class ManagedUserSerializer extends PaginatedListSerializer {
  protected payloadModelName = 'managed-users';
  primaryKey = 'user_id';
}
